import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear, format, subWeeks, subMonths } from 'date-fns'

export const thisWeek = () => {
  return {
    startDate: format(startOfWeek(new Date()), 'yyyy-MM-dd'),
    endDate: format(endOfWeek(new Date()), 'yyyy-MM-dd')
  }
}

export const lastWeek = () => {
  const previous = subWeeks(new Date(), 1)
  return {
    startDate: format(startOfWeek(previous), 'yyyy-MM-dd'),
    endDate: format(endOfWeek(previous), 'yyyy-MM-dd')
  }
}

export const thisMonth = () => {
  return {
    startDate: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
    endDate: format(endOfMonth(new Date()), 'yyyy-MM-dd')
  }
}
export const lastMonth = () => {
  const previous = subMonths(new Date(), 1)
  return {
    startDate: format(startOfMonth(previous), 'yyyy-MM-dd'),
    endDate: format(endOfMonth(previous), 'yyyy-MM-dd')
  }
}

export const thisYear = () => {
  return {
    startDate: format(startOfYear(new Date()), 'yyyy-MM-dd'),
    endDate: format(endOfYear(new Date()), 'yyyy-MM-dd')
  }
}
